import { MainLayout } from '@design-system/Layout';
import Pagination from '@design-system/Pagination';
import {
  getPageStats,
  getSellers,
  getSellersProducts,
  getLoading,
  getSellerId,
  getCategories,
  getLoadingProducts,
} from './redux/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { Body, Jumbo, ProductBody } from './style';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  get_sellers,
  get_products,
  get_partner_id,
  get_categories,
} from './redux/reducer';
import Skeleton from 'react-loading-skeleton';
import SellerProducts from '@design-system/Loaders/sellerProducts';
import useDebounce from './hooks/useDebounce';
import { getCart } from '@app/product/redux/selectors';
import { get_cart } from '@app/product/redux/reducer';
import { CartButton } from '@design-system/CartButton';
import { getLoggedInCart } from '@app/basket/redux/selectors';
import { get_logged_in_cart } from '@app/basket/redux/reducer';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ProductCard from './components/productCard';
import Filters from './components/filters';
import SearchComponent from './components/searchComponent';
import filterIcon from '@design-system/Assets/Filter.png';
import FilterModal from './components/filterModal';

const Sellers = () => {
  const seller = useSelector(getSellers);
  const products = useSelector(getSellersProducts);
  const pageStats = useSelector(getPageStats);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const dispatch = useDispatch();
  const loading = useSelector(getLoading);
  const partner = useSelector(getSellerId);
  const [searchString, setSearchString] = useState('');
  const debounced = useDebounce(searchString, 500);
  const categories = useSelector(getCategories);
  const [filter, setFilter] = useState('');
  const [selected, setSelected] = useState('');
  const loading_products = useSelector(getLoadingProducts);
  const token = localStorage.getItem('x-access-token');
  const cart = token ? useSelector(getLoggedInCart) : useSelector(getCart);
  const params = useParams();
  const [lowPrice, setLowPrice] = useState('');
  const [highPrice, setHighPrice] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [lowprice, setLowprice] = useState('');
  const [highprice, setHighprice] = useState('');

  useEffect(() => {
    if (partner) {
      dispatch(get_cart(partner));
      dispatch(get_logged_in_cart(partner));
    }
  }, [dispatch, partner]);

  useEffect(() => {
    if (params.id) {
      dispatch(get_partner_id(params.id));
    }
  }, [dispatch, params]);

  useEffect(() => {
    if (partner) {
      dispatch(get_sellers(partner));
      dispatch(get_categories(partner));
    }
  }, [dispatch, partner]);

  useEffect(() => {
    if (partner) {
      dispatch(
        get_products({
          id: partner,
          page: currentPage,
          limit: pageSize,
          debounced,
          filter,
          lowPrice,
          highPrice,
        }),
      );
    }
  }, [
    dispatch,
    partner,
    currentPage,
    pageSize,
    debounced,
    filter,
    lowPrice,
    highPrice,
  ]);

  const handlePageChange = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousChange = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handlePageSizeChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilter = (doc) => {
    setFilter(doc._id);
    setSelected(doc.name);
  };

  const resetFilter = () => {
    setFilter('');
    setSelected('');
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
  };

  const handlePriceFilter = (doc) => {
    setLowPrice(doc.low);
    setHighPrice(doc.high);
  };

  const resetPriceFilter = () => {
    setLowPrice('');
    setHighPrice('');
  };

  const handleSelectedFilter = (doc) => {
    setSelectedFilter(doc._id);
  };

  const activateFilter = () => {
    dispatch(
      get_products({
        id: partner,
        page: currentPage,
        limit: pageSize,
        debounced,
        filter: selectedFilter,
        lowPrice: lowprice,
        highPrice: highprice,
      }),
    );
    setIsOpen(!isOpen);
  };

  const resetMobileFilter = () => {
    setSelectedFilter('');
    setLowprice('');
    setHighprice('');
  };

  const handleMobilePriceFilter = (doc) => {
    setLowprice(doc.low);
    setHighprice(doc.low);
  };

  return (
    <MainLayout>
      <FilterModal
        isOpen={isOpen}
        toggle={() => setIsOpen(!isOpen)}
        categories={categories}
        handleSelectedFilter={handleSelectedFilter}
        selectedFilter={selectedFilter}
        activateFilter={activateFilter}
        resetMobileFilter={resetMobileFilter}
        seller={seller}
        lowprice={lowprice}
        handleMobilePriceFilter={handleMobilePriceFilter}
      />
      <Helmet>
        <meta charset="utf-8" />
        <link rel="icon" type="image/png" href={seller?.user?.photo_url} />
        <link rel="apple-touch-icon" href={seller?.user?.photo_url} />
        <meta name="description" content={seller?.short_bio} />
        <title>{seller?.business_name}</title>
      </Helmet>
      <Jumbo>
        <div>
          {loading ? (
            <Skeleton width={200} height={20} style={{ marginTop: '14px' }} />
          ) : (
            <h4 className="sellers_name">About Us</h4>
          )}
          {loading ? (
            <Skeleton width={150} style={{ marginBottom: '50px' }} />
          ) : (
            <p className="short_bio">{seller?.short_bio}</p>
          )}
        </div>
      </Jumbo>

      {cart?.length >= 1 && (
        <Link to="/basket">
          <CartButton />
        </Link>
      )}
      <Body>
        <ProductBody>
          <div className="left_side">
            <SearchComponent handleSearch={handleSearch} />

            <div className="filter_btn" onClick={() => setIsOpen(!isOpen)}>
              <img src={filterIcon} alt="filter_icon" />
            </div>
            <Filters
              categories={categories}
              filter={selected}
              handleFilter={handleFilter}
              resetFilter={resetFilter}
              seller={seller}
              handlePriceFilter={handlePriceFilter}
              resetPriceFilter={resetPriceFilter}
              lowPrice={lowPrice}
            />
          </div>

          <div>
            {loading_products ? (
              <div className="cards">
                {[...new Array(10)].map((_, idx) => (
                  <SellerProducts key={idx} />
                ))}
              </div>
            ) : (
              <div className="cards">
                {products.map((product) => (
                  <Link
                    style={{ textDecoration: 'none' }}
                    to={`/products/${product._id}`}
                    key={product._id}
                  >
                    <ProductCard product={product} seller={seller} />
                  </Link>
                ))}
              </div>
            )}

            {products?.length <= 0 && (
              <div style={{ display: 'grid', placeItems: 'center', height: '50vh' }}>
                <p>No Product Available</p>
              </div>
            )}

            {pageStats.docs >= 1 && (
              <Pagination
                itemsCount={pageStats.docs}
                pageSize={pageSize}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                onChangePageSize={handlePageSizeChange}
                handlePreviousChange={handlePreviousChange}
              />
            )}
          </div>
        </ProductBody>
      </Body>
    </MainLayout>
  );
};

export default Sellers;
